import axios from "axios";
var httpClientAnistia = axios.create({
    baseURL: "".concat(process.env.PORTAL_URL, "/api/backenddemo/anistia"),
});
export default httpClientAnistia;
